<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import FlowSelectPlanInboundWidget from '@/widgets/Flow/FlowSelectPlanInboundWidget/FlowSelectPlanInboundWidget.vue'

  useApiRequestsAbort()
</script>

<template>
  <FlowSelectPlanInboundWidget />
</template>
